<template>
  <el-dialog
    :visible="isVisible"
    v-loading="isLoading"
    custom-class="dialog-long-form"
    :closeOnClickModal="false"
    append-to-body
    :title="L10n('add-to-quote')"
    @close="close"
  >
    <el-tabs v-model="activeTab">
      <el-tab-pane
        v-for="mainTab in tabs"
        :key="mainTab.name"
        :name="mainTab.name"
      >
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{mainTab.label}}</span>
        </template>
        <component
          :is="mainTab.component"
          :data="data"
          @add-to="handlerAddTo"
        ></component>
      </el-tab-pane>
    </el-tabs>
    <template v-slot:footer>
      <button type="button" class="my-2 m-0 m-sm-2 btn btn-size-s btn-border grey btn-mobile-full" @click="close">{{L10n('cancel')}}</button>
      <button type="button" class="btn btn-size-s btn-mobile-full" @click="handlerAddManual">{{L10n('manual-add')}}</button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'IndexRFQDialogAddToRFQ2',
  components: {
    'tab-stock': () => import(/* webpackChunkName: 'Shared' */ './TabStock/Index'),
    'tab-supplier': () => import(/* webpackChunkName: 'Shared' */ './TabSupplier/Index')
  },
  props: {
    isLoading: { type: Boolean, default: false }
  },
  data () {
    return {
      isVisible: false,
      activeTab: 'stock',
      data: {},
      tabs: [
        { label: this.L10n('from-stock'), name: 'stock', component: 'tab-stock' },
        { label: this.L10n('from-supplier-rfq'), name: 'supplier', component: 'tab-supplier' }
      ]
    }
  },
  methods: {
    open (data, callback) {
      this.isVisible = true
      this.data = data
      this.callback = callback
    },
    close () {
      this.isVisible = false
    },
    handlerAddManual () {
      let data = {
        rfqid: this.data.rfqid,
        partID: this.data.partID,
        qty: this.data.qty
      }
      this.handlerAddTo(data)
    },
    handlerAddTo (data) {
      this.callback({ ...data, id: this.data.id })
    }
  }
}
</script>
